import { useQuery, DocumentNode } from "@apollo/client";


export interface Query<T> {
    loading: boolean;
    error?: { message: string };
    data: T  | undefined;
    refetch: () => void;
}


export function makeQuery<T>(query_value: DocumentNode, query_name: string){

    const { 
        loading, 
        error, 
        data, 
        refetch 
      } = useQuery<T>(query_value, {
        onCompleted: (data) => {
          console.log("Requête ", query_name," terminée avec succès", data);
        },
        onError: (error) => {
          console.log("Erreur lors de la requête ", query_name, " ", error);
        }
      });

    const query = {
        loading,
        error,
        data: data,
        refetch
    };

    return query;
}